"use strict";

angular.module("vendor")
.factory("CatalogDashboardService", function($resource, $http, FlashBag, appConfig) {
    var catalogDashboardService = $resource(appConfig.API_SERVER + "/catalog/vendor/dashboard/", {}, {
        query: {
            method: "GET",
            isArray: false
        }
    });

    return {
        query: function(page) {
            var params = {
                page: page
            };
            return catalogDashboardService.query(params,
                function(data) {
                },
                function errorCallback(response) {
                    FlashBag.apiError(response);
                }
            );
        },
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-dashboard/catalog-dashboard.factory.js
// module id = 880
// module chunks = 0